<template>
  <div class="Breadcrumbs">
    <div class="breadcrumbWrapper" v-for="breadcrumb in breadcrumbs" :key="breadcrumb.title">
      <template v-if="breadcrumb.link">
        <TextLink class="TextLink" :text="breadcrumb.title" size="sm" :to="breadcrumb.link" />
        <div class="icon">
          <LinkArrow class="LinkArrow" />
        </div>
      </template>
      <template v-else>
        {{ breadcrumb.title }}
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'
import { TextLink } from '@ka-nabellinc/ka-nabell-ui'
import { LinkArrow } from '@ka-nabellinc/ka-nabell-icons'
import type { Breadcrumb } from '@/types/breadcrumb'

export default defineNuxtComponent({
  components: {
    TextLink,
    LinkArrow,
  },
  props: {
    breadcrumbs: {
      type: Array as () => Breadcrumb[],
      required: true,
    },
  },
})
</script>

<style scoped>
.Breadcrumbs {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 4px;
}

.breadcrumbWrapper {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.15px;
}

.TextLink {
  white-space: nowrap;
}

.icon {
  width: 20px;
  height: 20px;
}

.LinkArrow {
  transform: rotate(180deg) scale(0.7);
}
</style>
